module.exports = __webpack_public_path__ + "img/sticker_5.c76f2254.svg";